import GeneralSection from '@/components/pages/configuration/GeneralSection';
import CamLayoutSection from '@/components/pages/configuration/CamLayoutSection';
import Title from '@/components/ui/Title';
import { useTranslation } from 'react-i18next';

export default function ConfigurationPage() {
  const { t } = useTranslation('settings');

  return (
    <div className="space-y-8">
      <Title level={1}>{t('pageTitle')}</Title>
      <GeneralSection />
      <CamLayoutSection />
    </div>
  );
}
